import { Type } from 'class-transformer';
import {
  IsArray,
  IsDate,
  IsDefined,
  IsEnum,
  IsNotEmpty,
  IsOptional,
  IsString,
  ValidateNested,
} from 'class-validator';
import { BaseDto } from '../../@base/base.dto';
import { EmailId } from '../../types';
import { EmailActions } from './email-actions.type';
import { EmailStatus } from './email-status.enum';
import { EmailTag } from './email-tags.enum';
import { EmailAttemptDto } from './sub-dto/email-attempt.dto';
import { EmailContextDto } from './sub-dto/email-context.dto';

export class EmailSummaryDto extends BaseDto<EmailId> {
  @IsString()
  @IsNotEmpty()
  action!: EmailActions | string;

  @IsEnum(EmailStatus)
  @IsNotEmpty()
  status!: EmailStatus;

  @IsEnum(EmailTag)
  @IsNotEmpty()
  tag!: EmailTag;

  @IsString()
  @IsNotEmpty()
  to!: string;

  @ValidateNested()
  @Type(() => EmailContextDto)
  @IsDefined()
  context!: EmailContextDto;

  @IsString()
  @IsNotEmpty()
  subject!: string;

  @IsString()
  @IsNotEmpty()
  text!: string;

  @IsString()
  @IsNotEmpty()
  html!: string;

  @IsDate()
  @IsOptional()
  sendDate?: Date;

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => EmailAttemptDto)
  attempts!: EmailAttemptDto[];
}
